<swiper [config]="options()" (swiper)="onSwiper($event)">
  @for (carouselItem of carouselItems(); track carouselItem.data()) {
    <ng-template swiperSlide>
      <ng-template
        *ngTemplateOutlet="
          carouselItem.data()?.template;
          context: { $implicit: carouselItem.data()?.slideData }
        " />
    </ng-template>
  }
</swiper>
